<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger>
      <slot />
    </DialogTrigger>

    <DialogContent class="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>{{
          t("settings.mcpServers.editDialog.title")
        }}</DialogTitle>
        <DialogDescription>
          {{ t("settings.mcpServers.editDialog.description") }}
        </DialogDescription>
      </DialogHeader>

      <McpServersForm :initial-values="mcpServer" @submit="onSubmit">
        <DialogFooter class="gap-2">
          <Button variant="outline" @click="isOpen = false">
            {{ t("settings.mcpServers.editDialog.cancelButton") }}
          </Button>
          <Button type="submit" :disabled="isLoading">
            <LoadingIndicator v-if="isLoading" class="mr-2" />
            {{ t("settings.mcpServers.table.actions.save") }}
          </Button>
        </DialogFooter>
      </McpServersForm>
    </DialogContent>
  </Dialog>
</template>
<script lang="ts" setup>
import { refreshApiMcpServersData } from "~/composables/api";
import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";

const { t } = useI18n();

const props = defineProps<{
  mcpServer: ApiMcpServer;
}>();

const isOpen = ref(false);
const isLoading = ref(false);

const { organizationId } = useOrganizationId();

// Reset loading state when dialog closes
watch(isOpen, (newValue) => {
  if (!newValue) {
    isLoading.value = false;
  }
});

const onSubmit = async (values: ApiMcpServer) => {
  isLoading.value = true;

  try {
    await $fetch(
      `/api/organizations/${organizationId.value}/mcpServers/${props.mcpServer.id}`,
      {
        method: "PUT",
        body: values
      }
    );
    isOpen.value = false;
    await refreshApiMcpServersData();
  } catch (error) {
    console.error("Failed to update MCP server:", error);
  } finally {
    isLoading.value = false;
  }
};
</script>
